import React from "react";
import { useParams } from "react-router-dom";
import SearchResults from "../searchResults/SearchResults";
import {
  humanizeSlug,
  parseCombinedSlug,
  parseAdultEducationServiceSlug,
} from "../../data/categoryLandingPages";

// Thin routing wrappers around SearchResults — each variant parses its
// pretty-URL path segment(s) into the same category/subject/location/role
// filters SearchResults already supports via query params, so there is
// only one search implementation to maintain.

export const TutorsLocationSubjectLanding = () => {
  const { location, subject } = useParams();
  const locationLabel = humanizeSlug(location);
  const subjectLabel = humanizeSlug(subject);

  return (
    <SearchResults
      presetLocation={locationLabel}
      presetSubject={subjectLabel}
      canonicalPath={`/tutors/${location}/${subject}`}
      metaTitle={`${subjectLabel} Tutors in ${locationLabel} | TutorsLinks`}
      metaDescription={`Find verified ${subjectLabel} tutors in ${locationLabel}, Nigeria. Compare prices, ratings, and teaching modes on TutorsLinks.`}
    />
  );
};

export const TutorsCombinedSlugLanding = () => {
  const { combinedSlug } = useParams();
  const { category, subject } = parseCombinedSlug(combinedSlug);
  const label = [subject, category].filter(Boolean).join(" ") ||
    humanizeSlug(combinedSlug);

  return (
    <SearchResults
      presetCategory={category}
      presetSubject={subject}
      canonicalPath={`/tutors/${combinedSlug}`}
      metaTitle={`${label} Tutors in Nigeria | TutorsLinks`}
      metaDescription={`Find verified ${label} tutors in Nigeria. Compare prices, ratings, and teaching modes on TutorsLinks.`}
    />
  );
};

export const AdultEducationServiceLanding = () => {
  const { serviceSlug } = useParams();
  const subjectLabel = parseAdultEducationServiceSlug(serviceSlug);
  const title = subjectLabel
    ? `${subjectLabel} Tutors for Adult Education | TutorsLinks`
    : "Adult Education Tutors in Nigeria | TutorsLinks";

  return (
    <SearchResults
      presetCategory="Adult Education"
      presetSubject={subjectLabel}
      canonicalPath={serviceSlug ? `/adult-education/${serviceSlug}` : "/adult-education"}
      metaTitle={title}
      metaDescription={`Find verified adult education tutors${subjectLabel ? ` for ${subjectLabel}` : ""} in Nigeria on TutorsLinks.`}
    />
  );
};

export const TrainingCentresLocationLanding = () => {
  const { location } = useParams();
  const locationLabel = humanizeSlug(location);
  const title = locationLabel
    ? `Training Centres in ${locationLabel} | TutorsLinks`
    : "Training Centres in Nigeria | TutorsLinks";

  return (
    <SearchResults
      presetRole="institution"
      presetLocation={locationLabel}
      canonicalPath={location ? `/training-centres/${location}` : "/training-centres"}
      metaTitle={title}
      metaDescription={`Find verified training centres${locationLabel ? ` in ${locationLabel}` : ""}, Nigeria on TutorsLinks.`}
    />
  );
};
